module.exports = __webpack_public_path__ + "img/tvcontrol.025fb3d7.png";